import { render, staticRenderFns } from "./DialogNewFeedback.vue?vue&type=template&id=68dcc39b&"
import script from "./DialogNewFeedback.vue?vue&type=script&lang=js&"
export * from "./DialogNewFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports